import Close from "Components/close";
import { themeVariables } from "Components/theme";
import React, { useCallback, useEffect, useMemo } from "react";
import { READ_ONLY_MODE } from "../types/readOnlyMode";
import locale from "./readOnlyIndication.locale";
import classNames from "classnames";
import styles from "./readOnlyIndication.module.css";
const SIZES = {
    INDICATION_SIZE: 3,
    PANEL_HEIGHT: 28
};
export default function ReadOnlyIndication(props) {
    const topLineStyle = useMemo(() => ({
        top: props.top,
        left: props.left,
        right: props.temporaryRight,
        height: SIZES.INDICATION_SIZE
    }), [props.top, props.left, props.temporaryRight]);
    const rightLineStyle = useMemo(() => ({
        top: props.top,
        right: props.temporaryRight,
        bottom: props.bottom,
        width: SIZES.INDICATION_SIZE
    }), [props.top, props.temporaryRight, props.bottom]);
    const bottomLineStyle = useMemo(() => ({
        left: props.left,
        right: props.temporaryRight,
        bottom: props.bottom,
        height: SIZES.INDICATION_SIZE
    }), [props.left, props.temporaryRight, props.bottom]);
    const leftLineStyle = useMemo(() => ({
        top: props.top,
        left: props.left,
        bottom: props.bottom,
        width: SIZES.INDICATION_SIZE
    }), [props.top, props.left, props.bottom]);
    const topPanelStyle = useMemo(() => ({
        top: props.top,
        left: "50%",
        height: SIZES.PANEL_HEIGHT,
        transform: "translateX(-50%)",
        borderBottomLeftRadius: themeVariables["border-radius-medium"],
        borderBottomRightRadius: themeVariables["border-radius-medium"],
        zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) + 2
    }), [props.top]);
    useEffect(() => {
        var _a;
        props.activeDocumentId &&
            props.finalReadOnlyMode &&
            props.finalReadOnlyMode !== props.readOnlyMode &&
            ((_a = props.onSetReadOnlyMode) === null || _a === void 0 ? void 0 : _a.call(props, props.activeDocumentId, props.finalReadOnlyMode));
    }, [props.finalReadOnlyMode, props.readOnlyMode]);
    const handleCloseReadOnlyMode = useCallback(() => {
        var _a;
        props.activeDocumentId &&
            ((_a = props.onSetReadOnlyMode) === null || _a === void 0 ? void 0 : _a.call(props, props.activeDocumentId, READ_ONLY_MODE.READ_WRITE));
    }, [props.onSetReadOnlyMode, props.activeDocumentId]);
    useEffect(() => {
        var _a;
        if (props.activeDocumentId) {
            (_a = props.onSetReadOnlyMode) === null || _a === void 0 ? void 0 : _a.call(props, props.activeDocumentId, READ_ONLY_MODE.READ_WRITE);
        }
    }, [props.activeDocumentId, props.activeDocumentType]);
    if (!props.finalReadOnlyMode ||
        props.finalReadOnlyMode !== READ_ONLY_MODE.READ_ONLY ||
        !props.activeDocumentId)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "bg-primary position-absolute", style: topLineStyle }),
        React.createElement("div", { className: "bg-primary position-absolute", style: rightLineStyle }),
        React.createElement("div", { className: "bg-primary position-absolute", style: bottomLineStyle }),
        React.createElement("div", { className: "bg-primary position-absolute", style: leftLineStyle }),
        React.createElement("div", { className: classNames("bg-primary", "position-absolute", "caption-with-actions-panel", "v-center-items", "no-gap", "unselectable", styles["view-mode"]), style: topPanelStyle },
            React.createElement("div", { className: "font-small text-white" }, locale.READ_ONLY_MODE),
            React.createElement(Close, { className: "text-white animate-hover-color-0_8", fontSize: 11, size: SIZES.PANEL_HEIGHT - 2, animateHoverColor: false, onClick: handleCloseReadOnlyMode }))));
}
